// src/components/ui/TypeSelect.tsx
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { SupportedPropertyType } from '@commenda/types';

export default function TypeSelect({
  value,
  onChange,
}: {
  value: SupportedPropertyType;
  onChange: (v: SupportedPropertyType) => void;
}) {
  return (
    <Select
      value={value}
      onValueChange={(val: SupportedPropertyType) => onChange(val)}
    >
      <SelectTrigger className="text-text-secondary txt-small-regular">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="text-text-secondary txt-small-regular">
        {Object.values(SupportedPropertyType).map((k) => (
          <SelectItem key={k} value={k}>
            {k}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
